export default __webpack_public_path__ + "static/organic-textile_wrap-ff033195059bb8ea3a72754008d7da1f.jpg";